export const USER_EDIT_TABS = Object.freeze({
  DETAILS: Object.freeze({ name: 'details', index: 0 }),
  NOTIFICATIONS: Object.freeze({ name: 'notifications', index: 1 }),
});

export const getUserEditTabIndex = tab => {
  const namedTab = Object.values(USER_EDIT_TABS).find(
    ({ name }) => name === tab,
  );
  return namedTab?.index ?? Number.parseInt(tab, 10) - 1;
};
